import { getHotels, getFastHotels } from '@shared/services/services';

export const fetchHotelSearchResults = async ({
  calendarValue,
  passengerValue,
  lodgingSelection,
  searchInfo,
  isDetailPage,
  isHomePage,
  user,
  checkVersion,
  setIsLoadingResults,
  setIsLoadingFastResults,
  setHotelSearchResults,
  setHotelFastSearchResults,
  setHotReferenceCities,
}) => {
  const shouldRunSearch =
    !!searchInfo.checkIn &&
    !!searchInfo.checkOut &&
    !isDetailPage &&
    !isHomePage;

  if (!shouldRunSearch) {
    return;
  }

  checkVersion({
    type: 'hotel',
    infoSearch: searchInfo,
    force: true,
  });

  const searchBody = {
    check_in: calendarValue.check_in,
    check_out: calendarValue.check_out,
    country_of_residence: 'AR',
    passengers: passengerValue.passengers,
    user_event: user?.id ?? null,
    search_option: lodgingSelection,
  };

  setHotReferenceCities(
    lodgingSelection.option?.reference_city?.id || lodgingSelection.option?.id
  );

  try {
    setHotelSearchResults({
      hotels: [],
      tokens: [],
      fav_messages: [],
      has_favorites: false,
    });

    setHotelFastSearchResults({
      hotels: [],
      tokens: [],
    });

    setIsLoadingResults(true);

    if (lodgingSelection?.type === 'city') {
      setIsLoadingFastResults(true);
      getFastHotels(searchBody)
        .then(fastResult => {
          setHotelFastSearchResults({
            hotels: fastResult?.results ?? [],
            tokens: fastResult?.token ?? [],
          });
          setIsLoadingFastResults(false);
        })
        .catch(error => {
          console.error('Error en fast search:', error);
          setHotelFastSearchResults({
            hotels: [],
            tokens: [],
          });
          setIsLoadingFastResults(false);
        });
    } else {
      setHotelFastSearchResults({
        hotels: [],
        tokens: [],
      });
      setIsLoadingFastResults(false);
    }

    try {
      const result = await getHotels(searchBody);
      setHotelSearchResults({
        hotels: result?.results ?? [],
        tokens: result?.token ?? [],
        fav_messages: result?.fav_messages ?? [],
        has_favorites: result?.has_favorites ?? false,
      });
    } catch (error) {
      console.error('Error en full search:', error);
      setHotelSearchResults({ hotels: [], tokens: [] });
    }
  } finally {
    setIsLoadingResults(false);
  }
};
